import { type ModalId } from '@heidi/schema/ml-scribe';

/**
 * Seen-state id for the Work-home Heidi II onboarding banner.
 *
 * Cast until ml-scribe `shared/enums/modal_tracking.py` replaces
 * `T4_CUSTOM_AUDIENCE_HEIDI_2_HOME_CHANGEBOARDING_BANNER` with this name and
 * `pnpm run schema:dev` picks it up. Then swap the cast for `ModalId.X`.
 * The string is frozen — it keys `seen_modals`.
 */
export const HEIDI_2_NEW_USER_ONBOARDING_BANNER_MODAL_ID =
  'T4_NEW_USER_HEIDI_2_ONBOARDING_BANNER' as ModalId;
